import React, { useState, useEffect, useContext, useRef } from 'react';
import './Sidebar.css';
import { FiLogOut } from "react-icons/fi";
import { AuthContext } from '../../context/AuthContext';
import ColorsMain from '../../colors/ColorsMain';
import { motion } from 'framer-motion';
import moment from 'moment';

import { ReactComponent as Home } from '../../assets/IconsColurs/IconsGeneral/home.svg';
import { ReactComponent as Wallet } from '../../assets/IconsColurs/IconsGeneral/wallet.svg';
import { ReactComponent as Cotizar } from '../../assets/IconsColurs/IconsGeneral/cotizar.svg';
import { useNavigate } from 'react-router-dom';
import UserMenu from "../../components/menus/UserMenu";
import LogoLarge from '../../assets/logos/logo_mas.png';
import LogoC from '../../assets/logos/logo_menos.png';
import axios from 'axios'


const Sidebar = () => {
    const userDetails = JSON?.parse(localStorage.getItem("userDetails"));
    const navigate = useNavigate();
    const { getAuthenticatedHeaders } = useContext(AuthContext);

    const [isCollapsed, setIsCollapsed] = useState(false);
    const [ShowPortafolio, setShowPortafolio] = useState(false);

    const { logout } = useContext(AuthContext);
    const [activeMenu, setActiveMenu] = useState('Dashboard');
    const [userIP, setUserIP] = useState("Cargando...");
    const fetchedIP = useRef(false); // Evita múltiples ejecuciones



    const lastLogin = moment(userDetails?.last_login).format("DD/MM/YYYY HH:mm");

    const handleMenuClick = (menu, path) => {
        setActiveMenu(menu);
        navigate(path);
    };
    const MovementsList = async () => {

        try {
            const response = await axios.post(`/api/investment`, {
                headers: await getAuthenticatedHeaders(),
                page: 1,
            });
            if (response.data.data.length > 1) {
                setShowPortafolio(true)
            } else {
                setShowPortafolio(false)
            }


        } catch (error) {
            console.error("Error fetching wallet balance:", error);
        }


    };
    useEffect(() => {
        if (!fetchedIP.current) {
            fetchedIP.current = true; // Marcar como ejecutado
            console.log("Obteniendo IP...");

            fetch('https://api64.ipify.org?format=json')
                .then(response => response.json())
                .then(data => setUserIP(data.ip))
                .catch(() => setUserIP("No disponible"));
        }
        MovementsList()
    }, []);
    return (
        <motion.div
            className="text-[#8A8A8E] h-screen p-2 relative"
            style={{
                backgroundColor: ColorsMain.bgLayout,
                width: isCollapsed ? 88 : 288,
                overflow: "visible",
            }}
            animate={{
                width: isCollapsed ? 88 : 288,
            }}
            transition={{
                duration: 0.5,
                ease: [0.25, 0.8, 0.5, 1],
            }}
        >
            {/* Logo */}
            <div className={`flex items-center mb-10 pt-10 ${isCollapsed ? 'justify-center' : 'pl-5'}`}>
                {isCollapsed ? (
                    <img src={LogoC} alt="Logo colapsado" />
                ) : (
                    <div className="w-full flex flex-row gap-2 items-center">
                        <img src={LogoLarge} alt="Logo expandido" />
                    </div>
                )}
            </div>

            {/* Menú */}
            <ul className="flex flex-col gap-2 px-2">
                {[{ name: 'Inicio', icon: <Home />, path: '/dashboard' },
                { name: 'Mis Cuentas', icon: <Wallet />, path: '/wallet' },
                { name: 'Cotizar', icon: <Cotizar />, path: '/cotizar' },
                    /*                 { name: 'Mi portafolio', icon: <Cotizar />, path: '/portafolio' },
                     */
                ].map(({ name, icon, path }) => (
                    path === '/portafolio' && !ShowPortafolio ? null :
                        < li
                            key={name}
                            className={`flex items-center gap-3 px-4 py-4 sidebar-hover-item 
                        ${activeMenu === name ? 'bg-[#13131A] text-white' : ''}
                        ${isCollapsed ? 'justify-center' : ''}
                    `}
                            title={name}
                            onClick={() => handleMenuClick(name, path)}
                        >
                            {icon}
                            {!isCollapsed && (
                                <motion.span
                                    initial={{ opacity: 0, x: -10 }}
                                    animate={{ opacity: 1, x: 0 }}
                                    exit={{ opacity: 0, x: -10 }}
                                    transition={{ duration: 0.5 }}
                                >
                                    {name}
                                </motion.span>
                            )}
                        </li>
                ))}
            </ul>

            {/* Cerrar sesión */}
            <div className="absolute bottom-14 ml-2 w-auto flex h-auto sidebar-hover-logout flex-col">
                <UserMenu isCollapsed={isCollapsed} userDetails={userDetails} SignOut={logout} />
            </div>

            {/* Última sesión e IP */}
            <div className="absolute bottom-4 left-2 right-2 text-xs text-gray-500 text-left ml-5">
                <p>Última sesión: {lastLogin}</p>
                <p>IP: {userIP}</p>
            </div>
        </motion.div >
    );
};

export default Sidebar;
